// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination--1L_-sT"};